import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';
import {Tab, Tabs} from '../../components/common/TabCustom';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, useLocation, Navigate} from "react-router-dom";

import {APPCONFIG} from '../../app.config';
import {useEntidad, useForm, useFormErrors, useNav, useLista, useUnsavedChangesGuard, useReporte} from '../../components/hooks';
import { ALERT_TYPE, CUENTA_STATE, OPERATION_MODE, ShowToastMessage, dataTaggerActionClear, dataTaggerActionSet } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../consts/validationMessage';

import {Loading, SectionHeading, SectionSidebar} from '../../components/common';
import ElementosGrid from '../../components/controls/ElementosGrid';
import {ManagedContext} from '../../context/custom';
import {getDateId} from '../../utils/convert';
import {CloneObject, DistinctArray, CompareDates, OpenObjectURL} from '../../utils/helpers';
import {isEmptyString} from '../../utils/validator';
import {MenuLateral, SectionForm} from './components';
import {
    AddCementerio,
    buildCementerioEntityInit,
    FetchUbicacionDefinicion,
    FindCementerio,
    MakeListDomiciliosRelacionados,
    ModifyBajaCuenta,
    ModifyCementerio,
    UpdateEntityRow
} from './utils';
import {FooterButtonVolver} from '../../components/buttons/FooterButtonVolver/FooterButtonVolver';
import {getDateNow} from '../../utils/convert';
import {PERMISSIONS} from '../../consts/permissions';

function CementerioView() {

    //parametros url
    const params = useParams();
    const location = useLocation();
    const previousFilters = location.state?.filters;

    //#region Init
    const entityInit = buildCementerioEntityInit();
    const menuesInit = {
        expedientes: false,
        certificadosEscribanos: false,
        relacionesCuentas: false,
        controladoresCuentas: false,
        zonasEntrega: false,
        aplicacionCreditos: false,
        condonacion: false,
        pagosAnticipados: false,
        planesPago: false
    };
    //#endregion
    const [tipoConstruccionFuneraria, setTipoConstruccionFuneraria] = useState({
        codigo: '',
        tieneUbicacion: false,
        tieneSuperficie: false
    });
    const [ubicacionDefinicion, setUbicacionDefinicion] = useState(null);
    const prevTipoIdRef = useRef(null);

    //#region Hooks
    const navigate = useNav()
    const {showMessageModal} = useContext(ManagedContext)

    const [state, setState] = useState({
        processKey: `Cementerio_${params.id ?? 0}_${getDateId()}`,
        id: params.id ? parseInt(params.id) : 0,
        mode: params.mode,
        loading: false,
        entity: entityInit,
        menues: menuesInit,
        showMenu: false,
    });

    const [toggledSidebarLeft, setToggledSidebarLeft] = useState(true);
    const [pendingChange, setPendingChange] = useState(state.mode === OPERATION_MODE.NEW);

    const dispatch = useDispatch();
    const dataTagger = useSelector((state) => state.dataTagger.data);

    const {allowNavigation} = useUnsavedChangesGuard(pendingChange);
    const navigateAllowed = (navOptions) => {
        allowNavigation();
        navigate(navOptions);
    };

    const [clases, setClases] = useState([]);
    const [tipoConstruccionFunerarias, setTipoConstruccionFunerarias] = useState([]);
    const [getListEntidad,] = useEntidad({
        entidades: ['ClaseElemento', 'TipoConstruccionFuneraria'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                const clases = getListEntidad('ClaseElemento').filter(clase => clase.idTipoTributo === 13);
                const tipoConstruccionFunerarias = getListEntidad('TipoConstruccionFuneraria');
                setClases(clases);
                setTipoConstruccionFunerarias(tipoConstruccionFunerarias);
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'ClaseElemento_TipoConstruccionFuneraria',
            timeout: 0
        }
    });

    const mount = () => {
        // alta obsoleta: en modo NEW el guard redirige a la grilla, no inicializar ni avisar
        if (state.mode === OPERATION_MODE.NEW) return;
        if (state.id > 0) {
            FindCementerio(state, setState, callbackNoSuccess, callbackError, callbackSuccessFindCementerio);
        } else {
            dispatch(dataTaggerActionSet(state.processKey, {
                Archivo: [],
                Observacion: [],
                Etiqueta: []
            }));
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Ingrese los datos y presione siguiente para confirmar el alta');
        }
    }
    useEffect(mount, []);

    const [listExpedientes, setListExpedientes] = useState([]);

    const updateListExpedientes = () => {
        var list = []
        const listsWithExpediente = [
            ...state.entity.recargosDescuentos
        ];
        listsWithExpediente.filter(f => f.state !== 'r').forEach(x => {
            if (x.idExpediente && x.idExpediente > 0 && list.indexOf(x.idExpediente) === -1) list.push(x.idExpediente)
        });

        setListExpedientes(list);
    }

    useEffect(updateListExpedientes, [state.entity.recargosDescuentos]);


    const [listDireccionesRelacionadas, setListDireccionesRelacionadas] = useState([]);
    const updateListDireccionesRelacionadas = () => {
        MakeListDomiciliosRelacionados(state.entity.vinculosCementerio)
            .then(list => {
                setListDireccionesRelacionadas(list);
            })
            .catch((error) => {
                const message = `Error consultando domicilios: ${error.message}`;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            });
    }

    useEffect(updateListDireccionesRelacionadas, [state.entity.vinculosCementerio]);

    const [countChangeInhumados, setCountChangeInhumados] = useState(0); //se usa para reforzar la reaccion del useMemo, ya que state.entity.inhumados no emite el evento en todos los casos donde cambian los inhumados
    let clasesXInhumados = useMemo(() => {
        const idsTipoConstruccionFunerariaXInhumados = DistinctArray(state.entity.inhumados.map(x => x.idTipoConstruccionFuneraria));
        const codigosTipoConstruccionFunerariaXInhumados = tipoConstruccionFunerarias.filter(f => idsTipoConstruccionFunerariaXInhumados.includes(f.id)).map(x => x.codigo);
        const codigosClasesXInhumados = codigosTipoConstruccionFunerariaXInhumados; //hay un mapeo directo entre ambas entidades
        const result = clases.map(x => {
            return {
                ...x,
                tipoConstruccionFuneraria: tipoConstruccionFunerarias.find(f => f.codigo === x.codigo),
                selected: codigosClasesXInhumados.includes(x.codigo)
            }
        });

        if (result.filter(f => f.selected).length > 0) SetTabActiveElementos(`elementos-${result.find(f => f.selected).codigo}`);

        return result;
    }, [state.entity.inhumados, tipoConstruccionFunerarias, clases, countChangeInhumados]);

    const [cementerio_formValues, cementerio_formHandle, , cementerio_formSet] = useForm({
        idEstadoCarga: 20,
        idTipoTributo: 0,
        fechaCargaInicio: null,
        fechaCargaFin: null,
        idTipoPrestador: 0,
        idTipoConstruccionFuneraria: 0,
        fechaAlta: null,
        fechaBaja: null,
        fechaPresentacion: null,
        fechaVencimiento: null,
        digitoVerificador: '',
        fechaConcesion: null,
        fechaEscritura: null,
        fechaSucesion: null,
        libroEscritura: '',
        folioEscritura: '',
        numeroSucesion: '',
        superficie: 0,
        largo: 0,
        ancho: 0,
        idCementerioInstitucion: 0,
        ...Object.fromEntries(Array.from({length: 15}, (_, i) => [`ubicacionValor${i + 1}`, '']))
    }, 'cementerio_');

    const [cuenta_formValues, cuenta_formHandle, , cuenta_formSet] = useForm({
        numeroCuenta: '',
        numeroWeb: '',
        idEstadoCuenta: 0
    }, 'cuenta_');
    //#endregion

    useEffect(() => {
        if (tipoConstruccionFunerarias.length > 0 && cementerio_formValues.idTipoConstruccionFuneraria > 0) {
            const tipoConstruccion = tipoConstruccionFunerarias.find(f => f.id === cementerio_formValues.idTipoConstruccionFuneraria);
            if (tipoConstruccion) {
                setTipoConstruccionFuneraria({
                    codigo: tipoConstruccion.codigo,
                    tieneUbicacion: tipoConstruccion.tieneUbicacion,
                    tieneSuperficie: tipoConstruccion.tieneSuperficie
                });
            }
        }
    }, [tipoConstruccionFunerarias, cementerio_formValues.idTipoConstruccionFuneraria]);

    useEffect(() => {
        let isCurrent = true;
        const idTipo = cementerio_formValues.idTipoConstruccionFuneraria;
        if (idTipo > 0) {
            FetchUbicacionDefinicion(idTipo)
                .then(def => { if (isCurrent) setUbicacionDefinicion(def); })
                .catch(() => { if (isCurrent) setUbicacionDefinicion(null); });
        } else {
            setUbicacionDefinicion(null);
        }

        if (prevTipoIdRef.current !== null && prevTipoIdRef.current !== 0 && prevTipoIdRef.current !== idTipo) {
            cementerio_formSet(prev => ({
                ...prev,
                ...Object.fromEntries(Array.from({length: 15}, (_, i) => [`ubicacionValor${i + 1}`, '']))
            }));
        }
        prevTipoIdRef.current = idTipo;
        return () => { isCurrent = false; };
    }, [cementerio_formValues.idTipoConstruccionFuneraria]);

    const today = useMemo(() => getDateNow(), []);

    const CAMPOS_SEPULTURA = ['idTipoConstruccionFuneraria', 'fechaAlta', 'fechaBaja', 'fechaPresentacion', 'superficie', 'largo', 'ancho', 'digitoVerificador'];
    const [cuentaOpen, setCuentaOpen] = useState(true);
    const [sepulturaOpen, setSepulturaOpen] = useState(false);
    const [ubicacionOpen, setUbicacionOpen] = useState(false);
    const [estadoOpen, setEstadoOpen] = useState(false);
    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    //handles
    const cuenta_formHandleProxy = (event) => {
        cuenta_formHandle(event);
        setPendingChange(true);
    }
    const cementerio_formHandleProxy = (event) => {
        cementerio_formHandle(event);
        setPendingChange(true);
    }
    const handleClickGuardar = () => {
        const errors = { ...getErrors(), ...getFormatErrors() };
        if (errors.idTipoPrestador || errors.idCementerioInstitucion) setCuentaOpen(true);
        if (CAMPOS_SEPULTURA.some(campo => errors[campo])) setSepulturaOpen(true);
        if (Object.keys(errors).some(campo => campo.startsWith('ubicacionValor'))) setUbicacionOpen(true);
        if (errors.idEstadoCarga) setEstadoOpen(true);
        if (!validate()) return;

        if (state.id === 0) {
            AddCementerio(state, setState, cementerio_formValues, cuenta_formValues, dispatch, navigateAllowed, dataTaggerActionClear, callbackNoSuccess, callbackError)
        } else {
            ModifyCementerio(state, setState, dataTagger, cementerio_formValues, cuenta_formValues, dispatch, dataTaggerActionClear, callbackNoSuccess, callbackError, callbackSuccessFindCementerio, tipoConstruccionFuneraria);
        }
    };

    const handleClickBaja = () => {
        const idCuenta = state.entity.cuenta.id
        showMessageModal({
            title: 'Confirmación',
            message: 'Al aceptar el cambio se procederá con la baja de la cuenta.',
            onConfirm: () => ModifyBajaCuenta(idCuenta, state, setState, dispatch, navigateAllowed, dataTaggerActionClear, callbackNoSuccess, callbackError)
        })
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindCementerio = (response) => {
        response.json()
            .then((data) => {

                //deserialize date fields
                if (data.cementerio.fechaCargaInicio) data.cementerio.fechaCargaInicio = new Date(data.cementerio.fechaCargaInicio);
                if (data.cementerio.fechaCargaFin) data.cementerio.fechaCargaFin = new Date(data.cementerio.fechaCargaFin);

                if (data.cuenta.fechaAlta) data.cuenta.fechaAlta = new Date(data.cuenta.fechaAlta);
                if (data.cuenta.fechaBaja) data.cuenta.fechaBaja = new Date(data.cuenta.fechaBaja);

                data.archivos.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.observaciones.forEach(x => {
                    if (x.fecha) x.fecha = new Date(x.fecha);
                });
                data.variablesCuenta.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.vinculosCementerio.forEach(x => {
                    if (x.fechaInstrumentoDesde) x.fechaInstrumentoDesde = new Date(x.fechaInstrumentoDesde);
                    if (x.fechaInstrumentoHasta) x.fechaInstrumentoHasta = new Date(x.fechaInstrumentoHasta);
                });
                data.condicionesEspeciales.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                data.recargosDescuentos.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                    if (x.fechaOtorgamiento) x.fechaOtorgamiento = new Date(x.fechaOtorgamiento);
                });
                data.debitosAutomaticos.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });
                data.inhumados.forEach(x => {
                    if (x.fechaNacimiento) x.fechaNacimiento = new Date(x.fechaNacimiento);
                    if (x.fechaDefuncion) x.fechaDefuncion = new Date(x.fechaDefuncion);
                    if (x.fechaIngreso) x.fechaIngreso = new Date(x.fechaIngreso);
                    if (x.fechaEgreso) x.fechaEgreso = new Date(x.fechaEgreso);
                    if (x.fechaTraslado) x.fechaTraslado = new Date(x.fechaTraslado);
                    if (x.fechaExhumacion) x.fechaExhumacion = new Date(x.fechaExhumacion);
                    if (x.fechaReduccion) x.fechaReduccion = new Date(x.fechaReduccion);
                    if (x.fechaHoraInicioVelatorio) x.fechaHoraInicioVelatorio = new Date(x.fechaHoraInicioVelatorio);
                    if (x.fechaHoraFinVelatorio) x.fechaHoraFinVelatorio = new Date(x.fechaHoraFinVelatorio);
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                    if (x.fechaPresentacion) x.fechaPresentacion = new Date(x.fechaPresentacion);
                    if (x.fechaConcesion) x.fechaConcesion = new Date(x.fechaConcesion);
                    if (x.fechaEscritura) x.fechaEscritura = new Date(x.fechaEscritura);
                    if (x.fechaSucesion) x.fechaSucesion = new Date(x.fechaSucesion);
                });
                data.elementos.forEach(x => {
                    if (x.fechaAlta) x.fechaAlta = new Date(x.fechaAlta);
                    if (x.fechaBaja) x.fechaBaja = new Date(x.fechaBaja);
                });

                setState(prevState => {
                    return {...prevState, loading: false, entity: data};
                });
                setPendingChange(false);

                if (data.cementerio.fechaAlta) data.cementerio.fechaAlta = new Date(data.cementerio.fechaAlta);
                if (data.cementerio.fechaBaja) data.cementerio.fechaBaja = new Date(data.cementerio.fechaBaja);
                if (data.cementerio.fechaPresentacion) data.cementerio.fechaPresentacion = new Date(data.cementerio.fechaPresentacion);
                if (data.cementerio.fechaVencimiento) data.cementerio.fechaVencimiento = new Date(data.cementerio.fechaVencimiento);
                if (data.cementerio.fechaConcesion) data.cementerio.fechaConcesion = new Date(data.cementerio.fechaConcesion);
                if (data.cementerio.fechaEscritura) data.cementerio.fechaEscritura = new Date(data.cementerio.fechaEscritura);
                if (data.cementerio.fechaSucesion) data.cementerio.fechaSucesion = new Date(data.cementerio.fechaSucesion);

                cementerio_formSet({
                    idEstadoCarga: data.cementerio.idEstadoCarga,
                    idTipoPrestador: data.cementerio.idTipoPrestador,
                    idTipoConstruccionFuneraria: data.cementerio.idTipoConstruccionFuneraria,
                    ...Object.fromEntries(
                        Array.from({length: 15}, (_, i) => [
                            `ubicacionValor${i + 1}`,
                            data.cementerio[`ubicacionValor${i + 1}`] || ''
                        ])
                    ),
                    fechaAlta: data.cementerio.fechaAlta,
                    fechaBaja: data.cementerio.fechaBaja,
                    fechaPresentacion: data.cementerio.fechaPresentacion,
                    fechaVencimiento: data.cementerio.fechaVencimiento,
                    digitoVerificador: data.cementerio.digitoVerificador,
                    fechaConcesion: data.cementerio.fechaConcesion,
                    fechaEscritura: data.cementerio.fechaEscritura,
                    fechaSucesion: data.cementerio.fechaSucesion,
                    libroEscritura: data.cementerio.libroEscritura,
                    folioEscritura: data.cementerio.folioEscritura,
                    numeroSucesion: data.cementerio.numeroSucesion,
                    superficie: data.cementerio.superficie,
                    largo: data.cementerio.largo,
                    ancho: data.cementerio.ancho,
                    idCementerioInstitucion: data.cementerio.idCementerioInstitucion,
                });
                cuenta_formSet({
                    numeroCuenta: data.cuenta.numeroCuenta,
                    numeroWeb: data.cuenta.numeroWeb,
                    idEstadoCuenta: data.cuenta.idEstadoCuenta
                });
                dispatch(dataTaggerActionSet(state.processKey, {
                    Archivo: data.archivos,
                    Observacion: data.observaciones,
                    Etiqueta: data.etiquetas
                }));
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    };

    //funciones
    function getErrors() {
        const errors = {};

        if (cementerio_formValues.idEstadoCarga === 0) errors.idEstadoCarga = VALIDATION_MESSAGE.REQUIRED_SHORT;
        if (state.mode === OPERATION_MODE.NEW) {
            if (cementerio_formValues.idTipoPrestador <= 0) errors.idTipoPrestador = VALIDATION_MESSAGE.REQUIRED_SHORT;
        }
        if (state.mode === OPERATION_MODE.EDIT) {
            if (cementerio_formValues.idCementerioInstitucion <= 0) errors.idCementerioInstitucion = VALIDATION_MESSAGE.REQUIRED_SHORT;
            // TIPO PRESTADOR INHUMADOS
            if (cementerio_formValues.idTipoPrestador === 380) {
                if (cementerio_formValues.idTipoConstruccionFuneraria <= 0) errors.idTipoConstruccionFuneraria = VALIDATION_MESSAGE.REQUIRED_OPTION;
                if (cementerio_formValues.fechaAlta == null) errors.fechaAlta = VALIDATION_MESSAGE.REQUIRED_SHORT;
                if (cementerio_formValues.fechaBaja != null &&
                    CompareDates(cementerio_formValues.fechaBaja, cementerio_formValues.fechaAlta) < 0) errors.fechaBaja = 'Anterior al alta';
                if (cementerio_formValues.fechaPresentacion != null &&
                    CompareDates(cementerio_formValues.fechaPresentacion, today) > 0) errors.fechaPresentacion = 'Posterior a hoy';

                if (!isEmptyString(tipoConstruccionFuneraria.codigo) && tipoConstruccionFuneraria.tieneUbicacion && ubicacionDefinicion) {
                    for (let i = 1; i <= 15; i++) {
                        if (ubicacionDefinicion[`ubicacionDescripcion${i}`] &&
                            ubicacionDefinicion[`ubicacionObligatorio${i}`] &&
                            !cementerio_formValues[`ubicacionValor${i}`]) {
                            errors[`ubicacionValor${i}`] = VALIDATION_MESSAGE.REQUIRED_SHORT;
                        }
                    }
                }

                if (tipoConstruccionFuneraria.tieneSuperficie) {
                    if (cementerio_formValues.superficie <= 0) errors.superficie = 'Ingresá un número mayor a cero';
                    if (cementerio_formValues.largo <= 0) errors.largo = 'Ingresá un número mayor a cero';
                    if (cementerio_formValues.ancho <= 0) errors.ancho = 'Ingresá un número mayor a cero';
                    if (cementerio_formValues.digitoVerificador.length === 0) errors.digitoVerificador = VALIDATION_MESSAGE.REQUIRED_SHORT;
                }
            }
        }
        return errors;
    }

    function getFormatErrors() {
        const errors = {};

        if (state.mode === OPERATION_MODE.EDIT && cementerio_formValues.idTipoPrestador === 380 &&
            cementerio_formValues.fechaAlta != null && CompareDates(cementerio_formValues.fechaAlta, today) > 0) {
            errors.fechaAlta = 'Posterior a hoy';
        }
        return errors;
    }

    function UpdateEntity(typeEntity, row) {
        // o:original a:add m:modify r:remove c:modify only childs
        let entity = CloneObject(state.entity);

        UpdateEntityRow(typeEntity, row, entity, countChangeInhumados, setCountChangeInhumados, state, setState);

        setState(prevState => {
            return {...prevState, entity: entity};
        });
        setPendingChange(true);
    }


    function SetTabActive(tab) {
        setState(prevState => {
            return {...prevState, tabActive: tab};
        });
    }

    function SetTabActiveElementos(tab) {
        setState(prevState => {
            return {...prevState, tabActiveElementos: tab};
        });
    }

    function ShowPopupMenu(menu) {
        let menues = CloneObject(menuesInit);
        menues[menu] = true;
        setState(prevState => {
            return {...prevState, showMenu: true, menues: menues};
        });
    }

    function HidePopupMenu() {
        setState(prevState => {
            return {...prevState, showMenu: false, menues: menuesInit};
        });
    }

    function ShowPage(partialUrl) {
        const url = APPCONFIG.SITE.WEBAPP + partialUrl + '/' + state.mode + '/' + state.entity.cuenta.id;
        window.open(url, '_blank');
    }

    function refetchCementerio() {
        setState(x => ({...x, loading: true}))
        setTimeout(() => {
            FindCementerio(state, setState, callbackNoSuccess, callbackError, callbackSuccessFindCementerio)
        }, 2000)
    }

    // La ficha sale completa y sin diálogo de opciones (contrato del Epic LAR-2347),
    // así que el menú la descarga directo en vez de abrir un modal.
    const [generateFicha, ] = useReporte({
        callback: (reporte, buffer, message, filename) => {
            if (buffer)
                OpenObjectURL(filename ?? `${reporte}.pdf`, buffer);
            else
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        }
    });

    const listMenu = [

        {
            menu: '1', items: [
                {
                    title: 'Expedientes', icon: 'draft', onClick: () => {
                        ShowPopupMenu('expedientes')
                    }
                },
                {
                    title: 'Ficha del cementerio', icon: 'description', onClick: () => {
                        generateFicha('CuentaFicha', {idCuenta: state.entity.cuenta.id})
                    }
                }
            ]
        },

        {
            menu: '2', items: [
                {
                    title: 'Gestión', icon: 'gavel', items: [
                        {
                            title: 'Certificados escribanos', onClick: () => {
                                ShowPopupMenu('certificadosEscribanos')
                            }
                        },
                        {
                            title: 'Relaciones', onClick: () => {
                                ShowPopupMenu('relacionesCuentas')
                            }
                        },
                        {
                            title: 'Controladores', onClick: () => {
                                ShowPopupMenu('controladoresCuentas')
                            }
                        },
                        {
                            title: 'Zonas entregas', onClick: () => {
                                ShowPopupMenu('zonasEntrega')
                            }
                        }
                    ]
                },
                {
                    title: 'Movimientos', icon: 'calculate', items: [
                        {
                            title: 'Cuenta corriente', onClick: () => {
                                ShowPage('cuenta-corriente/cuenta')
                            }, permisos: [PERMISSIONS.CUENTA_CORRIENTE_VIEW]
                        },
                        {
                            title: 'Créditos', onClick: () => {
                                ShowPopupMenu('aplicacionCreditos')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_EDIT, PERMISSIONS.CREDITO_EDIT]
                        },
                        {
                            title: 'Condonaciones', onClick: () => {
                                ShowPopupMenu('condonacion')
                            }, permisos: [PERMISSIONS.CONDONACION_EDIT]
                        },
                        {
                            title: 'Deuda', onClick: () => {
                                ShowPage('deuda')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        },
                        {
                            title: 'Planes de pago', onClick: () => {
                                ShowPopupMenu('planesPago')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        },
                        {
                            title: 'Liquidaciones', onClick: () => {
                                ShowPopupMenu('liquidaciones')
                            }, permisos: [PERMISSIONS.EMISION_EDIT, PERMISSIONS.LIQUIDACION_VIEW]
                        },
                        {
                            // pago-derecho-especial/:idCuenta no sigue el esquema de ShowPage (partialUrl/mode/id), por eso usamos window.open directo.
                            title: 'Derechos especiales', onClick: () => {
                                window.open(`${APPCONFIG.SITE.WEBAPP}pago-derecho-especial/${state.entity.cuenta.id}`, '_blank')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_EDIT]
                        },
                        {
                            title: 'Informe de deuda', onClick: () => {
                                ShowPopupMenu('informeDeuda')
                            }, permisos: [PERMISSIONS.CUENTA_PAGO_VIEW]
                        }
                    ]
                }
            ]
        },

    ];

    // El alta es por modal desde la grilla; /cementerio/new queda obsoleta.
    if (state.mode === OPERATION_MODE.NEW) return <Navigate to={'/cementerios' + location.search} replace />;

    return (
        <>

            <Loading visible={state.loading}></Loading>

            {state.showMenu &&
                <MenuLateral
                    state={state}
                    listExpedientes={listExpedientes}
                    listDireccionesRelacionadas={listDireccionesRelacionadas}
                    UpdateEntity={UpdateEntity}
                    HidePopupMenu={HidePopupMenu}
                />
            }

            <div className='section-frames'>

                <div className='section-sidebar-left'>
                    <SectionSidebar
                        collapsed={toggledSidebarLeft}
                        listMenu={listMenu}
                    />
                </div>

                <div className='section-main'>

                    <SectionHeading
                        handleToggleSidebar={(state.mode !== OPERATION_MODE.NEW) ? () => {
                            setToggledSidebarLeft(prevState => !prevState)
                        } : null}
                        isSidebarOpen={!toggledSidebarLeft}
                        titles={[
                            {title: 'Tributos'},
                            {title: 'Administración de cementerios', url: '/cementerios',},
                            {title: params.mode === OPERATION_MODE.NEW ? 'Nuevo' : `Número de cuenta: ${state.entity.cuenta.numeroCuenta}`},
                        ]}
                    />

                    <SectionForm
                        SetTabActive={SetTabActive}
                        setPendingChange={setPendingChange}
                        state={state}
                        cementerio_formValues={cementerio_formValues}
                        cementerio_formHandleProxy={cementerio_formHandleProxy}
                        cementerio_formSet={cementerio_formSet}
                        cuenta_formValues={cuenta_formValues}
                        cuenta_formHandleProxy={cuenta_formHandleProxy}
                        UpdateEntity={UpdateEntity}
                        handleClickBaja={handleClickBaja}
                        tipoConstruccionFuneraria={tipoConstruccionFuneraria}
                        setTipoConstruccionFuneraria={setTipoConstruccionFuneraria}
                        ubicacionDefinicion={ubicacionDefinicion}
                        errorOf={errorOf}
                        cuentaOpen={cuentaOpen}
                        setCuentaOpen={setCuentaOpen}
                        sepulturaOpen={sepulturaOpen}
                        setSepulturaOpen={setSepulturaOpen}
                        ubicacionOpen={ubicacionOpen}
                        setUbicacionOpen={setUbicacionOpen}
                        estadoOpen={estadoOpen}
                        setEstadoOpen={setEstadoOpen}
                        pendingChange={pendingChange}
                        refetchCementerio={refetchCementerio}
                    />

                </div>

            </div>

            <footer className='footer footer-action'>
                <div className='footer-action-container'>
                    <FooterButtonVolver pendingChange={pendingChange} processKey={state.processKey}
                                        filters={previousFilters} to="/cementerios"
                                        allowNavigation={allowNavigation}/>
                    {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                        <button className="btn action-button float-start m-left-10"
                                onClick={(event) => handleClickBaja()}>Baja</button>
                    }
                    {state.mode !== OPERATION_MODE.VIEW &&
                        <button
                            className={pendingChange ? "btn action-button float-end" : "btn action-button btn-disabled float-end"}
                            onClick={(event) => handleClickGuardar()}
                            disabled={!pendingChange}
                        >
                            {(state.mode === OPERATION_MODE.NEW) ? "Siguiente" : "Guardar"}
                        </button>
                    }
                </div>
            </footer>

        </>
    )
}

export default CementerioView;


